export enum Size {
  REGULAR = 'regular',
  SMALL = 'small',
}
